module.exports = __webpack_public_path__ + "static/media/gitam-logo.217ae10a.jpg";